module.exports = "/virtual-football/img/video/clubs/spain/atletico-bilbao.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/spain/atletico-bilbao.png
// module id = 304
// module chunks = 6